import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

// 2111 - Email & Print Configuration (Tasks 77530/77531 rework - split view).
// Backs src/views/settings/email-print-configuration.vue.
const EmailPrintConfigurationService = {
  // GET api/ScreenNameToLayout - backs the left selection list (read-only, no
  // per-cell editing - see GcDataGrid usage in the view).
  dataSourceConfig() {
    return ApiService.createDataSource("api/ScreenNameToLayout", {
      sort: [
        { selector: "ScreenName", asc: true },
        { selector: "ReportDisplayName", asc: true },
      ],
    });
  },

  // GET api/ScreenNameToLayout?$filter=RecordID eq <guid> - the single record for
  // the detail form, keyed by the route's :id.
  async getByRecordId(recordId) {
    const response = await ApiService.oDataGet({
      url: "api/ScreenNameToLayout",
      filter: `RecordID eq ${recordId}`,
      top: 1,
    });
    return (response.data && response.data.value) || [];
  },

  // GET api/ScreenNameToLayout/AvailableReports?screenName= - system-wide pair list,
  // never filtered by screenName (AD-04 revised, BR-2111-09) - screenName only affects
  // the IsLikelyMatch sort hint on the returned rows. Fetched once per selected
  // record (not per keystroke) and bound as a plain array on the Report Name
  // dropdown, since this isn't itself an EF-mapped OData entity set.
  async getAvailableReports(screenName) {
    const response = await ApiService.get(
      `api/ScreenNameToLayout/AvailableReports?screenName=${encodeURIComponent(
        screenName || ""
      )}`
    );
    return (response.data && response.data.value) || [];
  },

  // GET api/EmailTemplateList - unfiltered, every active template regardless of
  // document type (AD-05 resolved 2026-09-07, scoping by document type deferred).
  async getEmailTemplates() {
    const response = await ApiService.oDataGet({
      url: "api/EmailTemplateList",
      filter: "Inactive eq 'N'",
      select: ["RecordId", "Name"],
      orderby: "Name",
    });
    return response.data.value || [];
  },

  // POST api/Save_ScreenNameToLayout - batch write, changed rows only.
  async save(changes) {
    return await ApiService.post("api/Save_ScreenNameToLayout", {
      Changes: changes,
    });
  },
};

export default EmailPrintConfigurationService;
export { EmailPrintConfigurationService };
